import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const STORAGE = [
  { badge: "Do", title: "Cool, dark, upright", body: "Store bottles away from windows and heat sources. A wardrobe drawer at room temperature is ideal." },
  { badge: "Do", title: "Keep the cap sealed", body: "Oxygen slowly degrades the top notes. Replace the cap firmly after every use." },
  { badge: "Don’t", title: "Avoid the bathroom", body: "Steam, humidity, and temperature swings accelerate oxidation. Bathrooms are the worst place to store fragrance." },
  { badge: "Don’t", title: "Never freeze", body: "Freezing shocks the formula. Room temperature (18–22°C) is the sweet spot for longevity." },
];

const APPLICATION = [{
  heading: "How to apply for maximum performance",
  body: "1. Spray on skin, not on clothes. Fabric alters the drydown; skin warmth is what makes an extrait bloom properly.\n\n2. Two sprays is usually enough. Our extraits are concentrated — over-spraying can overwhelm rather than impress.\n\n3. Moisturised skin holds fragrance longer. A drop of unscented lotion on pulse points before spraying meaningfully improves longevity.\n\n4. Don’t rub your wrists together after applying. Rubbing shatters the top notes and disturbs the natural evaporation ladder.",
}];

const OILS = [{
  heading: "Pure-oil roll-on care",
  body: "Roll-ons wear closest to the skin — more intimate, less projection. Apply to warm pulse points (wrists, inside of elbows, behind the ears). Because they’re alcohol-free, they don’t ‘flash off’ the way sprays do, so a little goes a long way.\n\nIf the roller ball dries between uses, warm the bottle in your hands for a minute to restore even flow.",
}];

const SHELF = [{
  heading: "Shelf life",
  body: "Sealed bottles keep their integrity for 3–5 years. Once opened, aim to use each bottle within 24 months for optimal performance. If the colour has noticeably darkened or the top notes smell sharp, oxidation has set in.",
}];

const TRAVEL = [{
  heading: "Travelling with fragrance",
  body: "Our 10ml roll-ons are TSA and CATSA carry-on friendly. If you’re packing a 50ml, wrap it in a soft cloth inside a hard case and keep it in cabin baggage — hold luggage experiences pressure and temperature swings that damage the formula.",
}];

export default function CareGuidePage() {
  return (
    <PageShell
      slug="care-guide"
      testid="care-guide"
      eyebrow="Fragrance Care Guide"
      title="Care for it, and it will care for you."
      intro="A well-kept extrait can perform for years. Four habits keep every Scentodore fragrance at its best."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Storage</h2>
        <EditableFeatureGrid slug="care-guide" sectionKey="storage" fallback={STORAGE} />
      </div>
      <EditableSection slug="care-guide" sectionKey="application" fallback={APPLICATION} />
      <EditableSection slug="care-guide" sectionKey="oils" fallback={OILS} />
      <EditableSection slug="care-guide" sectionKey="shelf_life" fallback={SHELF} />
      <EditableSection slug="care-guide" sectionKey="travel" fallback={TRAVEL} />
    </PageShell>
  );
}
